var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelsMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF3B6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4093 17.7041C15.7351 18.0289 16.2622 18.0289 16.588 17.7041L23.0453 11.2467C23.1347 11.1577 23.1661 11.0257 23.1265 10.9059C23.0868 10.7861 22.9829 10.6989 22.858 10.6807C22.7946 10.6714 22.7307 10.6667 22.6666 10.6667H9.3333C9.26882 10.6667 9.20442 10.6713 9.14063 10.6807C9.01572 10.6989 8.91178 10.7861 8.87212 10.9059C8.83246 11.0257 8.86388 11.1577 8.9533 11.2467L15.4093 17.7041Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9253 11.8881C23.8797 11.8687 23.827 11.879 23.792 11.9141L19.6587 16.0474C19.5937 16.1127 19.5937 16.2181 19.6587 16.2834L23.0207 19.6454C23.1507 19.7709 23.2029 19.9568 23.1572 20.1316C23.1116 20.3064 22.9751 20.443 22.8003 20.4889C22.6255 20.5347 22.4396 20.4827 22.314 20.3527L18.952 16.9907C18.9207 16.9594 18.8783 16.9418 18.834 16.9418C18.7897 16.9418 18.7473 16.9594 18.716 16.9907L17.2967 18.4101C16.5808 19.1256 15.4205 19.1256 14.7047 18.4101L13.284 16.9921C13.2187 16.9272 13.1133 16.9272 13.048 16.9921L9.686 20.3541C9.48972 20.5435 9.17787 20.5406 8.98509 20.3477C8.79231 20.1547 8.78975 19.8428 8.97933 19.6467L12.3413 16.2847C12.4063 16.2195 12.4063 16.114 12.3413 16.0487L8.208 11.9154C8.17321 11.88 8.12021 11.8697 8.07467 11.8894C8.0299 11.9081 8.00053 11.9516 8 12.0001V20.0001C8 20.7365 8.59695 21.3334 9.33333 21.3334H22.6667C23.403 21.3334 24 20.7365 24 20.0001V12.0001C24.0002 11.951 23.9707 11.9068 23.9253 11.8881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelsMail);
export default __webpack_public_path__ + "static/media/ChannelsMail.c8976bed98357d944229437884b000b7.svg";
export { ForwardRef as ReactComponent };